import * as React from 'react';
import Box from '@mui/material/Box';
import Avatar from '@mui/material/Avatar';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import PersonAdd from '@mui/icons-material/PersonAdd';
import Settings from '@mui/icons-material/Settings';
import Logout from '@mui/icons-material/Logout';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import VisibilityIcon from '@mui/icons-material/Visibility';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import SupplyProduct from '@mui/icons-material/LocalShipping';
import AddSRV from '@mui/icons-material/PostAdd';
import AddTaskIcon from '@mui/icons-material/AddTask';
import MessageIcon from '@mui/icons-material/Message';
import SchoolIcon from '@mui/icons-material/School';
import MoneyOffIcon from '@mui/icons-material/MoneyOff';
import AppRegistrationIcon from '@mui/icons-material/AppRegistration';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import PaymentsIcon from '@mui/icons-material/Payments';
import MoneyIcon from '@mui/icons-material/Money';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';



export default function AccountMenu(props) {
    
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <React.Fragment>
            <Box sx={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}>
                <Tooltip title="More Options">
                    <IconButton
                        onClick={handleClick}
                        size="small"
                        sx={{ ml: 2 }}
                        aria-controls={open ? 'account-menu' : undefined}
                        aria-haspopup="true"
                        aria-expanded={open ? 'true' : undefined}
                    >
                        <MoreVertIcon />
                    </IconButton>
                </Tooltip>
            </Box>


            <Menu
                anchorEl={anchorEl}
                id="account-menu"
                open={open}
                onClose={handleClose}
                onClick={handleClose}
                PaperProps={{
                    elevation: 0,
                    sx: {
                        overflow: 'visible',
                       
                        filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                        mt: 1.5,
                        '& .MuiAvatar-root': {
                            width: 32,
                            height: 32,
                            ml: -0.5,
                            mr: 1,
                        },
                        '&:before': {
                            content: '""',
                            display: 'block',
                            position: 'absolute',
                            top: 0,
                            right: 14,
                            width: 10,
                            height: 10,
                            bgcolor: 'background.paper',
                            transform: 'translateY(-50%) rotate(45deg)',
                            zIndex: 0,
                        },
                    },
                }}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            >
               
                <MenuItem onClick={() => props.message(props.data)}>
                    <ListItemIcon>
                        <PaymentsIcon fontSize="small" />
                    </ListItemIcon>
                    Pay School Fees
                </MenuItem>        
                <MenuItem onClick={() => props.othercharge(props.data)}>
                    <ListItemIcon>
                        <MoneyIcon fontSize="small" />
                    </ListItemIcon>
                    Pay Other Charges
                </MenuItem>
                { props.admin.positiondescription!=="Administrator and Teller"&&

                <MenuItem onClick={() => props.editfees(props.data)}>
                    <ListItemIcon>
                        <PaymentsIcon fontSize="small" />
                    </ListItemIcon>
                    Add or Deduct Fees
                </MenuItem>    
}    
                
{ props.admin.positiondescription!=="Administrator and Teller"&&

                <MenuItem onClick={() => props.Arrears(props.data)}>
                    <ListItemIcon>
                        <AddSRV fontSize="small" />
                    </ListItemIcon>
                    Add Arrears Once
                </MenuItem> 
}

                <MenuItem onClick={() => props.discount(props.data)}>
                    <ListItemIcon>
                        <MoneyOffIcon fontSize="small" />
                    </ListItemIcon>
                    Add Fees Discount
                </MenuItem>
               
               
                <MenuItem onClick={() => props.dailyfee(props.data)}>
                    <ListItemIcon>
                        <AttachMoneyIcon fontSize="small" />
                    </ListItemIcon>
                    Set Daily Charge
                </MenuItem>
                <MenuItem onClick={() => props.weeklyfee(props.data)}>
                    <ListItemIcon>
                        <AttachMoneyIcon fontSize="small" />
                    </ListItemIcon>
                    Set Weekly Charge
                </MenuItem>  
                <MenuItem onClick={() => props.monthlyfee(props.data)}>
                    <ListItemIcon>
                        <AttachMoneyIcon fontSize="small" />
                    </ListItemIcon>
                    Set Monthly Charge
                </MenuItem>
                { props.admin.positiondescription!=="Administrator and Teller"&&
                <MenuItem onClick={() => props.viewbill(props.data)}>
                    <ListItemIcon>
                        <AppRegistrationIcon fontSize="small" />
                    </ListItemIcon>
                    Next Term Bill
                </MenuItem>
}
                <MenuItem onClick={() => props.view(props.data)}>
                    <ListItemIcon>
                        <VisibilityIcon fontSize="small" />
                    </ListItemIcon>
                    School Fees Information
                </MenuItem>
                
                <MenuItem onClick={() => props.viewcharges(props.data)}>
                    <ListItemIcon>
                        <AccountBalanceWalletIcon fontSize="small" />
                    </ListItemIcon>
                   Other Charges Information
                </MenuItem> 
                 
            </Menu>


        </React.Fragment>

    );
}
